export class Responsavel{
  id: number;
  id_incidente: number;
  id_responsavel_acolhimento: number;
  id_responsavel_geral: number;
}


// WEBPACK FOOTER //
// ./src/app/selecao-responsaveis/selecao-responsaveis.ts